import EmbeddedVideo from 'zoomforth_prompts/views/embedded_video.js';


(function() {
  
  // aspect ratio as width / height
  var WELCOME_VIDEO_ASPECT_RATIO = 3.0/2.0;

  zfrespond.views.WelcomeView = Backbone.View.extend({

    className: "welcome-view",

    template: ZFRESPOND_JST.welcome,

    events: {
      'click .action-continue': 'handleContinue',
      'submit form': 'handleSubmit',
      'click .action-scroll-down': 'handleScrollDown'
    },

    initialize: function(options) {
      var me = this;

      this.autoplay = options.autoplay;
      this.campaign = options.campaign;
      this.gotCampaign = $.Deferred();
      this.videoObj = null; 

      this.loggedInUserEmail = options.loggedInUserEmail;
      this.loggedInUserName = options.loggedInUserName;

      if (this.campaign.id) {
        this.gotCampaign.resolve(this.campaign);
      } 

      // Show or hide the name/email section when we have the campaign
      this._nameEmailSectionVisible = true;
      this.gotCampaign.done(function() {
        me._nameEmailSectionVisible = false;
        me.showHideNameEmailInputSection();
      });

      // Skip collecting email / name if we're in "logged in user mode"
      if (options.loggedInUserEmail) {
        this.gotCampaign.resolve(null);      
      }
    },

    render: function() {
      var $videoContainer;
      this.$el.html(this.template({ 
        htmlIntroMessage: this.model.get('html_intro_message'),
        introVideo: this.model.hasWelcomeVideo(),
        loggedInUserEmail: this.loggedInUserEmail,
        loggedInUserName: this.loggedInUserName
      }));
      
      $videoContainer = this.$('.video-container');
      $videoContainer.height($videoContainer.width() * (1/WELCOME_VIDEO_ASPECT_RATIO));      

      if(this.model.hasWelcomeVideo()) {
        this.videoObj = new EmbeddedVideo(
          this.model.getEmbeddedVideoParams(
            this.$('.video-container'),
            !!this.autoplay
          )
        );
      }

      this.showHideNameEmailInputSection();
      return this;
    },

    showHideNameEmailInputSection: function() {
      if (this._nameEmailSectionVisible) {
        this.$('.name-email-container').show();
        this.$('.continue-container').hide();
      } else {
        this.$('.name-email-container').hide();
        this.$('.continue-container').show();
      }
    },

    handleContinue: function(e) {
      e.preventDefault();
      this.$('form').submit();
    },

    handleSubmit: function(e) {
      var me = this;
      var parsedAddress = window.emailAddresses.parseOneAddress(
          this.$('form input[name=email_address]').val()
        );
      var fullName = this.$('form input[name=full_name]').val();

      e.preventDefault(); // Dont do browser form submit

      if (!parsedAddress || !parsedAddress.address) {
        this.$('form input[name=email_address]').addClass('invalid-email').focus();
        return;
      }

      this.campaign.save({
        'media_collector_id': this.model.id,
        'collector_contact': {
          'email_address': parsedAddress.address,
          'full_name': fullName
        }

      }).done(function() {

        me.gotCampaign.resolve(me.campaign);

        window.setTimeout(function() {
          me.trigger('goto:main');
        }, 500);

      }).fail(me.gotCampaign.reject);

    },

    handleScrollDown: function() {
      this.trigger('goto:main');
      if (this.videoObj) {
        this.videoObj.pause();
      }
    }

  });

}());